/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarProveedor" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreProveedor" />
  <LoadScreen v-if="mostrarLoaderDos" />

  <LayoutPrincipal>
    <ContainerWhite>

      <div class="header-proveedores">
        <div class="tituloModulo">Módulo de Proveedores</div>
        
        <div class="control-modo-wrapper">
          <div class="control-modo">
            <span :class="{ 'activo': !usarPersonalizados }">Referencia</span>
            <label class="switch">
              <input type="checkbox" v-model="usarPersonalizados">
              <span class="slider round"></span>
            </label>
            <span :class="{ 'activo': usarPersonalizados }">Personal</span>
          </div>
        </div>
      </div>

      <div class="aviso-culiacan" :class="{'aviso-blue': usarPersonalizados}">
        <div class="icono-aviso">
          <i :class="usarPersonalizados ? 'fas fa-info-circle' : 'fas fa-map-marker-alt'"></i>
        </div>
        <div class="texto-aviso">
          {{ usarPersonalizados 
            ? 'Gestiona tus proveedores. Solo se permite 1 por categoría.' 
            : 'Precios referencia mercado Culiacán.' 
          }}
        </div>
      </div>

      <div class="contenedor-principal">

        <section class="seccion-categoria">
          <div class="header-categoria">
            <h3 class="titulo-cat"><i class="fas fa-bolt"></i> Eléctricos</h3>
            <button class="btn-circle-add" 
              v-if="usarPersonalizados && !proveedorElectricoActual" 
              @click="mostrarAddProveedor('Electrico')">
              <i class="fas fa-plus"></i>
            </button>
          </div>

          <div class="card-row" v-if="proveedorElectricoActual">
            <span class="badge-tipo-mobile">{{ proveedorElectricoActual.esDefault ? 'Ref.' : 'Personal' }}</span>

            <div class="card-left">
              <div class="card-icon-mini electrico"><i class="fas fa-bolt"></i></div>
              <div class="card-info">
                <h4 class="prov-nombre">{{ proveedorElectricoActual.Nombre }}</h4>
                <p class="prov-ubi"><i class="fas fa-map-marker-alt"></i> {{ proveedorElectricoActual.ciudad || 'Sin ubicación' }}</p>
              </div>
            </div>
            
            <div class="card-right">
              <span class="badge-tipo-desktop">{{ proveedorElectricoActual.esDefault ? 'Referencia' : 'Personal' }}</span>
              <div class="acciones-row">
                <button class="btn-action btn-detalles" @click="mostrarTabla(proveedorElectricoActual.id_proveedor, 'electricos', proveedorElectricoActual.esDefault)">
                  <i class="fas fa-list"></i> <span class="btn-text">Ver Costos</span>
                </button>
                <div class="group-edit-delete" v-if="!proveedorElectricoActual.esDefault">
                  <button class="btn-action btn-icon-only btn-editar" @click="mostrarEditar(proveedorElectricoActual.id_proveedor, 'electricos')">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button class="btn-action btn-icon-only btn-eliminar" @click="confirmarEliminacion(proveedorElectricoActual, 'electricos')">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="empty-row" v-else>
            <span class="txt-empty">Sin proveedor asignado.</span>
            <button v-if="usarPersonalizados" class="btn-txt-add" @click="mostrarAddProveedor('Electrico')">Asignar</button>
          </div>
        </section>

        <section class="seccion-categoria">
          <div class="header-categoria">
            <h3 class="titulo-cat"><i class="fas fa-solar-panel"></i> Fotovoltaicos</h3>
            <button class="btn-circle-add" v-if="usarPersonalizados && !proveedorFotovoltaicoActual" @click="mostrarAddProveedor('Fotovolcaico')"><i class="fas fa-plus"></i></button>
          </div>

          <div class="card-row" v-if="proveedorFotovoltaicoActual">
            <span class="badge-tipo-mobile">{{ proveedorFotovoltaicoActual.esDefault ? 'Ref.' : 'Personal' }}</span>
            <div class="card-left">
              <div class="card-icon-mini solar"><i class="fas fa-solar-panel"></i></div>
              <div class="card-info">
                <h4 class="prov-nombre">{{ proveedorFotovoltaicoActual.Nombre }}</h4>
                <p class="prov-ubi"><i class="fas fa-map-marker-alt"></i> {{ proveedorFotovoltaicoActual.ciudad || 'Sin ubicación' }}</p>
              </div>
            </div>
            <div class="card-right">
              <span class="badge-tipo-desktop">{{ proveedorFotovoltaicoActual.esDefault ? 'Referencia' : 'Personal' }}</span>
              <div class="acciones-row">
                <button class="btn-action btn-detalles" @click="mostrarTabla(proveedorFotovoltaicoActual.id_proveedor, 'fotovoltaicos', proveedorFotovoltaicoActual.esDefault)">
                   <i class="fas fa-list"></i> <span class="btn-text">Ver Costos</span>
                </button>
                <div class="group-edit-delete" v-if="!proveedorFotovoltaicoActual.esDefault">
                  <button class="btn-action btn-icon-only btn-editar" @click="mostrarEditar(proveedorFotovoltaicoActual.id_proveedor, 'fotovoltaicos')"><i class="fas fa-pencil-alt"></i></button>
                  <button class="btn-action btn-icon-only btn-eliminar" @click="confirmarEliminacion(proveedorFotovoltaicoActual, 'fotovoltaicos')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>

           <div class="empty-row" v-else>
            <span class="txt-empty">Sin proveedor asignado.</span>
            <button v-if="usarPersonalizados" class="btn-txt-add" @click="mostrarAddProveedor('Fotovolcaico')">Asignar</button>
          </div>
        </section>

        <section class="seccion-categoria">
          <div class="header-categoria">
            <h3 class="titulo-cat"><i class="fas fa-tools"></i> Ferreteros</h3>
            <button class="btn-circle-add" v-if="usarPersonalizados && !proveedorFerreteroActual" @click="mostrarAddProveedor('Ferreteria')"><i class="fas fa-plus"></i></button>
          </div>

          <div class="card-row" v-if="proveedorFerreteroActual">
            <span class="badge-tipo-mobile">{{ proveedorFerreteroActual.esDefault ? 'Ref.' : 'Personal' }}</span>
            <div class="card-left">
              <div class="card-icon-mini ferretero"><i class="fas fa-tools"></i></div>
              <div class="card-info">
                <h4 class="prov-nombre">{{ proveedorFerreteroActual.Nombre }}</h4>
                <p class="prov-ubi"><i class="fas fa-map-marker-alt"></i> {{ proveedorFerreteroActual.ciudad || 'Sin ubicación' }}</p>
              </div>
            </div>
            <div class="card-right">
              <span class="badge-tipo-desktop">{{ proveedorFerreteroActual.esDefault ? 'Referencia' : 'Personal' }}</span>
              <div class="acciones-row">
                <button class="btn-action btn-detalles" @click="mostrarTabla(proveedorFerreteroActual.id_proveedor, 'ferreteros', proveedorFerreteroActual.esDefault)">
                   <i class="fas fa-list"></i> <span class="btn-text">Ver Costos</span>
                </button>
                <div class="group-edit-delete" v-if="!proveedorFerreteroActual.esDefault">
                  <button class="btn-action btn-icon-only btn-editar" @click="mostrarEditar(proveedorFerreteroActual.id_proveedor, 'ferreteros')"><i class="fas fa-pencil-alt"></i></button>
                  <button class="btn-action btn-icon-only btn-eliminar" @click="confirmarEliminacion(proveedorFerreteroActual, 'ferreteros')"><i class="fas fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>

           <div class="empty-row" v-else>
            <span class="txt-empty">Sin proveedor asignado.</span>
            <button v-if="usarPersonalizados" class="btn-txt-add" @click="mostrarAddProveedor('Ferreteria')">Asignar</button>
          </div>
        </section>

      </div>
    </ContainerWhite>

    <AgregarProveedor v-if="mostrarModalAgregar" :tipoPreseleccionado="tipoParaAgregar" @cancelar="mostrarModalAgregar = false" @guardado="agregarProveedor" />
    <EditarProveedor v-if="mostrarModalEditar" :proveedor="proveedorSeleccionado" @cancelar="mostrarModalEditar = false" @actualizar="manejarActualizacion" />
    <TablaProveedor v-if="mostrarModalTablaDetalles" :ferreteria="proveedorSeleccionadoTabla" @cancelar="mostrarModalTablaDetalles = false" />
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import AgregarProveedor from "../components/Proveedores/AgregarProveedor.vue";
import EditarProveedor from "../components/Proveedores/EditarProveedor.vue";
import ModalExito from "../components/Modales/ModalExito.vue";
import ModalConfirmacion from "../components/Modales/ModalConfirmacion.vue";
import LoadScreen from "../components/Forms/LoadScreen.vue";
import TablaProveedor from "../components/Proveedores/TablaProveedor.vue";
import providerService from "../services/providerService.js";

export default {
  components: {
    LayoutPrincipal, ContainerWhite, AgregarProveedor, EditarProveedor,
    ModalExito, ModalConfirmacion, LoadScreen, TablaProveedor,
  },
  data() {
    return {
      usarPersonalizados: false,
      misProveedores: { electricos: [], fotovoltaicos: [], ferreteros: [] },
      defaultProveedores: {
        electricos: [{ id_proveedor: 9991, Nombre: "Suministros Eléctricos Culiacán", ciudad: "Culiacán, Sin", Tipo: "Electrico", esDefault: true }],
        fotovoltaicos: [{ id_proveedor: 9993, Nombre: "Solar Energy Sinaloa", ciudad: "Culiacán, Sin", Tipo: "Fotovolcaico", esDefault: true }],
        ferreteros: [{ id_proveedor: 9994, Nombre: "Ferretería del Centro", ciudad: "Culiacán, Sin", Tipo: "Ferreteria", esDefault: true }]
      },
      mostrarModalAgregar: false, mostrarModalEditar: false, mostrarModalConfirmacion: false,
      mostrarLoaderDos: false, mostrarExito: false, proveedorSeleccionado: null,
      nombreProveedor: "", mostrarModalTablaDetalles: false, proveedorSeleccionadoTabla: null,
      TipoProveedorAEliminar: null, tipoParaAgregar: "",
    };
  },
  computed: {
    proveedorElectricoActual() {
      const lista = this.usarPersonalizados ? this.misProveedores.electricos : this.defaultProveedores.electricos;
      return lista.length > 0 ? lista[0] : null;
    },
    proveedorFotovoltaicoActual() {
      const lista = this.usarPersonalizados ? this.misProveedores.fotovoltaicos : this.defaultProveedores.fotovoltaicos;
      return lista.length > 0 ? lista[0] : null;
    },
    proveedorFerreteroActual() {
      const lista = this.usarPersonalizados ? this.misProveedores.ferreteros : this.defaultProveedores.ferreteros;
      return lista.length > 0 ? lista[0] : null;
    }
  },
  methods: {
    async obtenerProveedores() {
      try {
        const response = await providerService.getAllProviders();
        const all = response.data;
        this.misProveedores.electricos = all.filter(p => p.Tipo === 'Electrico').map(p => ({...p, esDefault: false}));
        this.misProveedores.fotovoltaicos = all.filter(p => p.Tipo === 'Fotovolcaico').map(p => ({...p, esDefault: false}));
        this.misProveedores.ferreteros = all.filter(p => p.Tipo === 'Ferreteria').map(p => ({...p, esDefault: false}));
      } catch (error) { console.error(error); }
    },
    mostrarAddProveedor(tipo) { this.tipoParaAgregar = tipo; this.mostrarModalAgregar = true; },
    mostrarEditar(id, Tipo) {
      const lista = this.misProveedores[Tipo === 'electricos' ? 'electricos' : (Tipo === 'fotovoltaicos' ? 'fotovoltaicos' : 'ferreteros')];
      const prov = lista.find(p => p.id_proveedor === id);
      if (prov) { this.proveedorSeleccionado = { ...prov }; this.mostrarModalEditar = true; }
    },
    mostrarTabla(id, Tipo, esDefault) {
      const lista = esDefault ? this.defaultProveedores[Tipo] : this.misProveedores[Tipo];
      const prov = lista.find(p => p.id_proveedor === id);
      if (prov) { this.proveedorSeleccionadoTabla = { ...prov }; this.mostrarModalTablaDetalles = true; }
    },
    confirmarEliminacion(prov, Tipo) {
      this.proveedorSeleccionado = prov; this.nombreProveedor = prov.Nombre; this.TipoProveedorAEliminar = Tipo; this.mostrarModalConfirmacion = true;
    },
    async eliminarProveedor() {
      this.mostrarModalConfirmacion = false; this.mostrarLoaderDos = true;
      try {
        await providerService.deleteProvider(this.proveedorSeleccionado.id_proveedor);
        this.misProveedores[this.TipoProveedorAEliminar] = [];
        this.mostrarExito = true; setTimeout(() => (this.mostrarExito = false), 1500);
      } catch (e) { console.error(e); } finally { this.mostrarLoaderDos = false; }
    },
    async manejarActualizacion() { this.mostrarModalEditar = false; this.mostrarExito = true; setTimeout(() => (this.mostrarExito = false), 1500); await this.obtenerProveedores(); },
    cancelarEliminacion() { this.mostrarModalConfirmacion = false; },
    agregarProveedor(nuevo) {
      const TipoData = nuevo.Tipo;
      let key = 'electricos'; if (TipoData === 'Fotovolcaico') key = 'fotovoltaicos'; if (TipoData === 'Ferreteria') key = 'ferreteros';
      this.misProveedores[key] = [{ ...nuevo, id_proveedor: Date.now(), esDefault: false }];
      this.mostrarModalAgregar = false; this.mostrarExito = true; setTimeout(() => (this.mostrarExito = false), 1500);
    }
  },
  mounted() { this.obtenerProveedores(); },
};
</script>

<style scoped>
.header-proveedores { 
  display: flex; justify-content: space-between; align-items: center; 
  padding: 20px 30px; 
}
.tituloModulo { font-size: 28px; color: #2a428c; font-weight: 800; font-style: italic; }

.control-modo {
  display: flex; align-items: center; gap: 10px;
  background: #f1f1f1; padding: 8px 15px; border-radius: 30px;
  white-space: nowrap;
}
.control-modo span { font-size: 13px; font-weight: 600; color: #aaa; transition: 0.3s; }
.control-modo span.activo { color: #333; }
.switch { position: relative; display: inline-block; width: 40px; height: 22px; margin: 0 5px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 34px; }
.slider:before { position: absolute; content: ""; height: 16px; width: 16px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
input:checked + .slider { background-color: #29b9f6; }
input:checked + .slider:before { transform: translateX(18px); }

.aviso-culiacan {
  margin: 0 30px 20px; padding: 12px 20px;
  background-color: #fff8e1; border-left: 4px solid #ffca28; border-radius: 4px;
  display: flex; align-items: center; gap: 15px; font-size: 14px; color: #6d4c04;
}
.aviso-blue { background-color: #e3f2fd; border-left-color: #2196f3; color: #0d47a1; }

.contenedor-principal { padding: 0 30px 40px; display: flex; flex-direction: column; gap: 25px; }
.header-categoria { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; border-bottom: 1px solid #eee; padding-bottom: 8px; }
.titulo-cat { font-size: 18px; color: #333; margin: 0; font-weight: 700; display: flex; align-items: center; gap: 8px; }

.btn-circle-add {
  width: 30px; height: 30px; border-radius: 50%; border: none; background: #29b9f6; color: white;
  cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.card-row {
  display: flex; align-items: center; justify-content: space-between;
  background: white; border: 1px solid #e0e0e0; border-radius: 10px;
  padding: 15px 20px; box-shadow: 0 2px 5px rgba(0,0,0,0.03); position: relative;
}
.card-left { display: flex; align-items: center; gap: 15px; flex: 1; }
.card-icon-mini {
  width: 45px; height: 45px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 20px;
}
.electrico { background: #fff8e1; color: #ffab00; }
.solar { background: #e0f7fa; color: #00acc1; }
.ferretero { background: #eceff1; color: #546e7a; }

.prov-nombre { margin: 0; font-size: 16px; font-weight: 700; color: #2c3e50; line-height: 1.2; }
.prov-ubi { margin: 3px 0 0; font-size: 13px; color: #888; }

.card-right { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
.badge-tipo-desktop {
  font-size: 10px; padding: 2px 8px; border-radius: 10px; background: #f0f0f0; color: #666; font-weight: 600; text-transform: uppercase;
}
.badge-tipo-mobile { display: none; }

.acciones-row { display: flex; gap: 8px; align-items: center; }

.btn-action {
  background: none; border: none; cursor: pointer; transition: all 0.2s; 
  display: flex; align-items: center; justify-content: center; gap: 6px; border-radius: 6px;
}
.btn-detalles { color: #29b9f6; font-weight: 600; font-size: 13px; background: #fff3e0; padding: 8px 12px; }
.btn-icon-only { width: 32px; height: 32px; color: #777; background: #f9f9f9; }
.btn-editar:hover { color: #f39c12; background: #fff8e1; }
.btn-eliminar:hover { color: #e74c3c; background: #ffebee; }

.group-edit-delete { display: flex; gap: 8px; }

.empty-row { background: #fafafa; border: 1px dashed #ddd; border-radius: 8px; padding: 15px; display: flex; justify-content: space-between; }
.txt-empty { font-size: 14px; color: #999; }
.btn-txt-add { background: none; border: none; color: #29b9f6; font-weight: 700; text-decoration: underline; font-size: 14px; }

@media (max-width: 768px) {
  
  .header-proveedores {
    flex-direction: column; align-items: flex-start; gap: 15px; padding: 15px 20px;
  }
  .tituloModulo { font-size: 24px; }
  .control-modo-wrapper { width: 100%; display: flex; justify-content: center; }
  .control-modo { width: 100%; justify-content: space-between; }

  .contenedor-principal { padding: 0 20px 30px; }
  .aviso-culiacan { margin: 0 20px 20px; }

  .card-row {
    flex-direction: column; align-items: flex-start; padding: 15px;
  }
  
  .badge-tipo-desktop { display: none; }
  .badge-tipo-mobile {
    display: block; position: absolute; top: 12px; right: 12px;
    font-size: 10px; padding: 3px 8px; background: #f0f0f0; color: #666; border-radius: 10px;
  }

  .card-left { 
    width: 100%; margin-bottom: 15px; 
    padding-right: 40px; 
  }
  
  .card-right { 
    width: 100%; align-items: stretch; 
  }
  
  .acciones-row {
    width: 100%; 
    justify-content: space-between; 
    border-top: 1px solid #f0f0f0; padding-top: 12px; 
  }

  .btn-detalles { flex: 1; justify-content: center; padding: 10px; margin-right: 10px; }
  .btn-icon-only { width: 40px; height: 40px; font-size: 16px; }
  
  .group-edit-delete { gap: 10px; }
}
</style>